import { BTooltip } from "bootstrap-vue";
import Back from "@@/core/components/shared/Back/Back";
import {
  BFormGroup,
  BFormTextarea,
  BFormInput,
} from "bootstrap-vue";

export default {
  name: "OrderHeader",
  components: {
    BTooltip,
    Back,
    BFormGroup,
    BFormTextarea,
    BFormInput,
  },
  data() {
    return {
      trackingCode: null,
      merchantUniqueId: null,
      orderDescription: null,
      password: null,
      type: null,
      amount: 0,
      admin: null,
      passwordDigikala: null,
    }
  },
  props: {
    order: Object,
    supportRequests: Array,
  },
  mounted(){
    this.homeRequest();
  },
  methods: {
    refundOrder() {
      this.$emit("refundOrderEmiter");
    },
    async homeRequest(){
      const response = await this.$axios.get('admin/home');
      console.log(response.data.data);
      this.admin = response.data.data.admin;
      
    },
    orderEdit() {
      this.$emit("order-edit");
    },
    printOrder() {
      this.$emit("print-order");
    },
    async inquiry() {
      try {
        const response = await this.$axios.get(`admin/digify/inquiry-by-admin/${this.order.id}`);
        console.log(response.data,'response.data');
        this.$root.notify(response.data.message, 'success');
      } catch (error) {  
        this.$root.notify(error)
      }
    },
    async refundPost() {
      const data = {
        id: this.order.id,
      };
      try {
        const response = await this.$axios.post('admin/orders-post-suspend', data);
        this.$root.notify(response.data.message, 'success');
      } catch (error) {  
        this.$root.notify(error)
      }
    },
    async submitData() {
      const data = {
        tracking_code: this.trackingCode,
        amount: this.amount,
        password: this.password,
        type: this.type,
      };
      try {
        const response = await this.$axios.post('admin/manual-digipay-refund', data);
        this.$root.notify(response.data.message, 'success');
        this.isButtonDisabled = true;  
      } catch (error) {  
        this.$root.notify(error)
      }
    },
    async submitDescriptionChanged() {
      console.log(this.orderDescription,'this.orderDescription');
      
      const data = {
        description: this.orderDescription,
      };
      try {
        const response = await this.$axios.put(`admin/orders-update-description/${this.order.id}`, data);
        this.$root.notify(response.data.message, 'success');
        this.isButtonDisabled = true;  
      } catch (error) {  
        this.$root.notify(error)
      }
    },
    async submitDigikalaData() {
      const data = {
        merchant_unique_id: this.merchantUniqueId,
        password: this.passwordDigikala,
      };
      try {
        const response = await this.$axios.post('admin/refund-order-digikala', data);
        this.$root.notify(response.data.message, 'success');
        this.isButtonDisabled = true;  
      } catch (error) {  
        this.$root.notify(error)
      }
    }
  },
};
